export function createDisplayName(displayName: Maybe<string>): string {
  return `JoyKitV2.${displayName || 'Component'}`;
}
